import React from 'react'
import { Route, Switch } from 'react-router'

import Layout from './containers/Layout'
import SignIn from './containers/SignIn'
import Authorization from './containers/Authorization'
import App from './containers/App'
import Parametros from './containers/Parametros'
import Usuarios from './containers/Usuarios'
import Parametros1 from './containers/Parametros1'
import Error404 from './containers/Error404'
import Error401 from './containers/Error401'
import CreacionSolicitudServicio from './containers/CreacionSolicitudServicio'
import CreacionSolicitudServicioOT from './containers/CreacionSolicitudServicioOT'
import CreacionSolicitudBI from './containers/CreacionSolicitudBI'
import Solicitudes from './containers/Solicitudes'
import SolicitudServicio from './containers/SolicitudServicio'
import Plantillas from './containers/Plantillas'
import Garantias from './containers/Garantias'
import SolicitudServicioOT from './containers/SolicitudServicioOT'
import SolicitudBI from './containers/SolicitudBI'
import CreacionContratoAnual from './containers/CreacionContratoAnual'
import ContratoAnual from './containers/ContratoAnual'
import ExternosAprobaciones from './containers/ExternosAprobaciones'
import CreacionTiquetesAereo from './containers/CreacionTiquetesAereo'
import TiquetesAereos from './containers/TiquetesAereos'
import Grupos from './containers/Grupos'
import Otrosi from './containers/Otrosi'
import BusquedaDocumentos from './containers/BusquedaDocumentos'
import Documento from './components/BusquedaDocumento/Documento'
import Reportes from './containers/Reportes'
import ExternosCotizaciones from './containers/ExternosCotizaciones'
import CreacionSolicitudHoteles from './containers/CreacionSolicitudHoteles'

import SolicitudHoteles from './containers/SolicitudHoteles'
import CambiarContrasena from './containers/CambiarContrasena'
import Maestra from './containers/Maestra'
import Delegados from './containers/Delegados'
import AdminDB from './containers/AdminDB'

const prefix = window.FOLDER


export default (
	<Switch>
		<Route exact path={`${prefix}/signin`} component={ SignIn } />
		<Layout>
			<Switch>

				<Route exact path={`${prefix}/`} component={ Authorization(App, false) } />
				<Route exact path={`${prefix}/solicitudes/servicios`} component={ Authorization(CreacionSolicitudServicio) } />
				<Route exact path={`${prefix}/solicitudes/servicios-oficina-tecnica`} component={ Authorization(CreacionSolicitudServicioOT) } />
				<Route exact path={`${prefix}/solicitudes/contratos-anuales`} component={ Authorization(CreacionContratoAnual) } />
				<Route exact path={`${prefix}/solicitudes/bienes-investigacion`} component={ Authorization(CreacionSolicitudBI) } />
				<Route exact path={`${prefix}/solicitudes/contratos-anuales/:id`} component={ Authorization(ContratoAnual) } />
				<Route path={`${prefix}/solicitudes/servicios/:id`} component={ Authorization(SolicitudServicio) } />
				<Route path={`${prefix}/solicitudes/servicios-oficina-tecnica/:id`} component={ Authorization(SolicitudServicioOT) } />
				<Route path={`${prefix}/solicitudes/bienes-investigacion/:id`} component={ Authorization(SolicitudBI) } />
				<Route path={`${prefix}/solicitudes/abiertas`} component={ Solicitudes } />
				<Route path={`${prefix}/admin/parametros`} component={ Authorization(Parametros) } />
				<Route path={`${prefix}/usuarios`} component={ Authorization(Usuarios) } />
				<Route path={`${prefix}/parametros`} component={ Parametros1 } />
				<Route path={`${prefix}/grupos`} component={ Authorization(Grupos) } />
				<Route exact path={`${prefix}/plantillas`} component={ Authorization(Plantillas) } />
				<Route exact path={`${prefix}/garantias`} component={ Authorization(Garantias) } />
				<Route exact path={`${prefix}/externos/aprobaciones`} component={ Authorization(ExternosAprobaciones) } />
				<Route exact path={`${prefix}/solicitudes/tiquetes-aereos`} component={ Authorization(CreacionTiquetesAereo) } />
				<Route exact path={`${prefix}/solicitudes/tiquetes-aereos/:id`} component={ Authorization(TiquetesAereos) } />
				<Route exact path={`${prefix}/solicitudes/otrosi/:id`} component={ Authorization(Otrosi) } />
				<Route exact path={`${prefix}/documentos/busqueda`} component={ Authorization(BusquedaDocumentos) } />
				<Route exact path={`${prefix}/documentos/:id`} component={ Authorization(Documento) } />
				<Route exact path={`${prefix}/reportes/`} component={ Authorization(Reportes) } />
				<Route exact path={`${prefix}/externos/cotizaciones`} component={ Authorization(ExternosCotizaciones) } />
				<Route exact path={`${prefix}/solicitudes/hoteles`} component={ Authorization(CreacionSolicitudHoteles) } />
				<Route exact path={`${prefix}/solicitudes/hoteles/:id`} component={ Authorization(SolicitudHoteles) } />
				<Route exact path={`${prefix}/cambiar-contrasena`} component={ Authorization(CambiarContrasena) } />
				<Route exact path={`${prefix}/maestras`} component={ Authorization(Maestra) } />
				<Route exact path={`${prefix}/delegados`} component={ Authorization(Delegados) } />
				<Route exact path={`${prefix}/database-client`} component={ Authorization(AdminDB) } />

				<Route path={`${prefix}/unauthorized`} component={ Error401 } />
				<Route component={ Error404 } />

			</Switch>
		</Layout>
	</Switch>
)


// WEBPACK FOOTER //
// ./src/routes.jsx